import React, { useState, useEffect } from "react"
import {
  CardBody,
  Container,
  Row,
  Col,
  Card,
  Form,
  Input,
  Button,
  Table,
  Modal,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Label,
} from "reactstrap"
import classnames from "classnames"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import ReactPaginate from "react-paginate"
import axios from "axios"
import { baseurl, imgUrl } from "Baseurls"

function Support() {
  const [modal_small, setmodal_small] = useState(false)
  const [modal_small1, setmodal_small1] = useState(false)
  const [modal_small12, setmodal_small12] = useState(false)
  const [docsupport, setdocsupport] = useState([])
  const [usersupport, setusersupport] = useState([])
  const [form1, setform1] = useState([])

  const [activeTab1, setactiveTab1] = useState("1")
  const toggle1 = tab => {
    if (activeTab1 !== tab) {
      setactiveTab1(tab)
    }
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)

  function tog_small() {
    setmodal_small(!modal_small)
  }

  function tog_small1() {
    setmodal_small1(!modal_small1)
  }
  function tog_small12() {
    setmodal_small12(!modal_small12)
  }

  const handleChange1 = e => {
    let myUser = { ...form1 }
    myUser[e.target.name] = e.target.value
    setform1(myUser)
  }

  useEffect(() => {
    GetAllBanners()
  }, [])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const [listPerPage] = useState(10)
  const [pageNumber, setPageNumber] = useState(0)
  const [listPerPage1] = useState(10)
  const [pageNumber1, setPageNumber1] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = docsupport.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(docsupport.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }
  const pagesVisited1 = pageNumber1 * listPerPage1
  const lists1 = usersupport.slice(pagesVisited1, pagesVisited1 + listPerPage1)
  const pageCount1 = Math.ceil(usersupport.length / listPerPage1)
  const changePage1 = ({ selected }) => {
    setPageNumber1(selected)
  }

  const EditBanner = () => {
    var token = datas
    var formid = form1._id
    const bodydata = {
      status: form1.status,
      reply: form1.reply,
    }
    const api =
      form1.doctorId == undefined
        ? "request/updateUserstatus/"
        : "request/update/"

    axios
      .put(baseurl + api + formid, bodydata, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast.success(res.data.message)
            GetAllBanners()
            setmodal_small(false)
            clearForm1()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast.error(error.response.data.message)
          }
        }
      )
  }

  const handleSubmit1 = e => {
    e.preventDefault()
    EditBanner()
  }

  const GetAllBanners = () => {
    var token = datas
    axios
      .post(
        baseurl + "request/getalluseranddoctorrequests",
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setdocsupport(res.data.doctorRequests)
        setusersupport(res.data.userRequests)
      })
  }
  const clearForm1 = () => {
    setform1({
      status: "",
      status: "reply",
    })
  }

  const getpopup = data => {
    setform1(data)
    tog_small()
  }

  const getpopup1 = data => {
    setform1(data)
    tog_small1()
  }
  const getpopup12 = data => {
    setform1(data)
    tog_small12()
  }

  const [search, setsearch] = useState([])

  const searchAll = e => {
    let myUser = { ...search }
    myUser[e.target.name] = e.target.value
    setsearch(myUser)

    var token = datas
    axios
      .post(
        baseurl +
          "request/getalluseranddoctorrequests?searchQuery=" +
          `${e.target.value}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setdocsupport(res.data.doctorRequests)
        setusersupport(res.data.userRequests)
      })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Allude" breadcrumbItem="Support" />
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col md="6">
                      <Nav pills className="navtab-bg nav-justified">
                        <NavItem className="border border-primary rounded m-1">
                          <NavLink
                            style={{ cursor: "pointer", padding: "10px" }}
                            className={classnames({
                              active: activeTab1 === "1",
                            })}
                            onClick={() => {
                              toggle1("1")
                            }}
                          >
                            Doctor's
                          </NavLink>
                        </NavItem>
                        <NavItem className="border border-primary rounded m-1">
                          <NavLink
                            style={{ cursor: "pointer", padding: "10px" }}
                            className={classnames({
                              active: activeTab1 === "2",
                            })}
                            onClick={() => {
                              toggle1("2")
                            }}
                          >
                            User's
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </Col>
                    <Col md="6">
                      <div style={{ float: "right" }}>
                        <Input
                          type="search"
                          className="form-control"
                          placeholder="Search.."
                          value={search.search}
                          onChange={searchAll}
                          name="search"
                        />
                      </div>
                    </Col>
                  </Row>
                  <TabContent activeTab={activeTab1} className="text-muted">
                    <TabPane tabId="1">
                      <div>
                        <div className="table-responsive">
                          <Table className="table table-bordered mb-4 mt-2">
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Ticket Id</th>
                                <th>Date / Time</th>
                                <th>Doctor Name</th>
                                <th>Title</th>
                                <th>Image</th>
                                <th>Description</th>
                                <th>Status</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {lists.map((data, key) => (
                                <tr key={key}>
                                  <th>{(pageNumber - 1) * 10 + key + 11}</th>
                                  <td>{data.ticketId}</td>
                                  <td>
                                    {data?.date} / {data?.time}
                                  </td>
                                  <td>{data.doctorName}</td>
                                  <td>{data.reason}</td>
                                  <td className="text-center">
                                    <i
                                      onClick={() => {
                                        getpopup12(data)
                                      }}
                                      style={{ fontSize: "18px" }}
                                      className="bx bx-show text-warning"
                                      title="View Image"
                                      type="button"
                                    />
                                  </td>
                                  <td>
                                    {data.description.slice(0, 30) + "..."}
                                  </td>
                                  <td>{data.status}</td>
                                  <td>
                                    <Button
                                      onClick={() => {
                                        getpopup1(data)
                                      }}
                                      className="m-1"
                                      size="sm"
                                      color="warning"
                                      outline
                                      title="View"
                                    >
                                      <i className="bx bx-show "></i>
                                    </Button>
                                    <Button
                                      onClick={() => {
                                        getpopup(data)
                                      }}
                                      disabled={data.status == "solved"}
                                      className="m-1"
                                      size="sm"
                                      color="success"
                                      outline
                                      title="Edit"
                                    >
                                      <i className="bx bx-edit "></i>
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                          <div className="mt-3" style={{ float: "right" }}>
                            <ReactPaginate
                              previousLabel={"Previous"}
                              nextLabel={"Next"}
                              pageCount={pageCount}
                              onPageChange={changePage}
                              containerClassName={"pagination"}
                              previousLinkClassName={"previousBttn"}
                              nextLinkClassName={"nextBttn"}
                              disabledClassName={"disabled"}
                              activeClassName={"active"}
                              total={lists.length}
                            />
                          </div>
                        </div>
                      </div>
                    </TabPane>
                    <TabPane tabId="2">
                      <div>
                        <div className="table-responsive">
                          <Table className="table table-bordered mb-4 mt-2">
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Ticket Id</th>
                                <th>Date / Time</th>
                                <th>User Name</th>
                                <th>Title</th>
                                <th>Image</th>
                                <th>Description</th>
                                <th>Status</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {lists1.map((data, key) => (
                                <tr key={key}>
                                  <th>{(pageNumber1 - 1) * 10 + key + 11}</th>
                                  <td>{data.ticketId}</td>
                                  <td>
                                    {data?.date} / {data?.time}
                                  </td>
                                  <td>{data.userName}</td>
                                  <td>{data.reason}</td>
                                  <td className="text-center">
                                    <i
                                      onClick={() => {
                                        getpopup12(data)
                                      }}
                                      title="View Image"
                                      style={{ fontSize: "18px" }}
                                      className="bx bx-show text-warning"
                                      type="button"
                                    />
                                  </td>
                                  <td>
                                    {data.description.slice(0, 30) + "..."}
                                  </td>
                                  <td>{data.status}</td>
                                  <td>
                                    <Button
                                      onClick={() => {
                                        getpopup1(data)
                                      }}
                                      className="m-1"
                                      size="sm"
                                      color="warning"
                                      outline
                                      title="View"
                                    >
                                      <i className="bx bx-show "></i>
                                    </Button>
                                    <Button
                                      onClick={() => {
                                        getpopup(data)
                                      }}
                                      disabled={data.status == "solved"}
                                      className="m-1"
                                      size="sm"
                                      color="success"
                                      outline
                                      title="Edit"
                                    >
                                      <i className="bx bx-edit "></i>
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                          <div className="mt-3" style={{ float: "right" }}>
                            <ReactPaginate
                              previousLabel={"Previous"}
                              nextLabel={"Next"}
                              pageCount={pageCount1}
                              onPageChange={changePage1}
                              containerClassName={"pagination"}
                              previousLinkClassName={"previousBttn"}
                              nextLinkClassName={"nextBttn"}
                              disabledClassName={"disabled"}
                              activeClassName={"active"}
                              total={lists1.length}
                            />
                          </div>
                        </div>
                      </div>
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Modal
          size="md"
          isOpen={modal_small}
          toggle={() => {
            tog_small()
          }}
          centered
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="mySmallModalLabel">
              Replay
            </h5>
            <button
              onClick={() => {
                setmodal_small(false)
              }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form
              onSubmit={e => {
                handleSubmit1(e)
              }}
            >
              <Col md={12}>
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Status <span className="text-danger">*</span>
                  </Label>
                  <select
                    onChange={e => {
                      handleChange1(e)
                    }}
                    name="status"
                    value={form1.status}
                    required
                    className="form-select"
                  >
                    <option value="">Select</option>
                    <option value="pending">Pending</option>
                    <option value="solved">Solved</option>
                  </select>
                </div>
              </Col>
              <Col md={12}>
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">Message</Label>
                  <Input
                    onChange={e => {
                      handleChange1(e)
                    }}
                    name="reply"
                    value={form1.reply}
                    type="textarea"
                    className="form-control"
                    id="basicpill-firstname-input1"
                    placeholder="Enter Message"
                  />
                </div>
              </Col>
              <div style={{ float: "right" }}>
                <Button
                  onClick={() => {
                    setmodal_small(false)
                  }}
                  color="danger"
                  type="button"
                >
                  Cancel <i className="fas fa-times-circle"></i>
                </Button>
                <Button className="m-1" color="success" type="submit">
                  Submit <i className="fas fa-check-circle"></i>
                </Button>
              </div>
            </Form>
          </div>
        </Modal>
        <Modal
          size="md"
          isOpen={modal_small1}
          toggle={() => {
            tog_small1()
          }}
          centered
        >
          <div className="modal-header">
            <h5>Details</h5>
            <button
              onClick={() => {
                setmodal_small1(false)
              }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div>
              <Row>
                <Col md="4">
                  <div>
                    <b>Request Id </b>
                  </div>
                  <div>
                    <b>Title </b>
                  </div>
                  <div>
                    <b>Message </b>
                  </div>
                </Col>
                <Col md="8">
                  <div>: # {form1.ticketId}</div>
                  <div>: {form1.reason} </div>
                  <div>: {form1.description}</div>
                </Col>
              </Row>
              <h5 className="my-2 border-bottom">Admin replay</h5>
              <Row>
                <Col md="4">
                  <div>
                    <b> </b>
                  </div>
                  <div>
                    <b>Message </b>
                  </div>
                </Col>
                <Col md="8">
                  <div>: {form1.reply}</div>
                </Col>
              </Row>
            </div>

            <div className="mt-3" style={{ float: "right" }}>
              <Button
                onClick={() => {
                  setmodal_small1(false)
                }}
                color="danger"
                type="button"
              >
                Cancel <i className="fas fa-times-circle"></i>
              </Button>
            </div>
          </div>
        </Modal>
        <Modal
          size="md"
          isOpen={modal_small12}
          toggle={() => {
            tog_small12()
          }}
          centered
        >
          <div className="modal-header">
            <h5>File</h5>
            <button
              onClick={() => {
                setmodal_small12(false)
              }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div>
              {form1.image == "" || form1.image == undefined ? (
                <h5 className="text-center">No Data...</h5>
              ) : (
                <img
                  src={imgUrl + form1.image}
                  style={{ width: "100%", height: "400px" }}
                />
              )}
            </div>

            <div className="mt-3" style={{ float: "right" }}>
              <Button
                onClick={() => {
                  setmodal_small12(false)
                }}
                color="danger"
                type="button"
              >
                Cancel <i className="fas fa-times-circle"></i>
              </Button>
            </div>
          </div>
        </Modal>
        <ToastContainer />
      </div>
    </React.Fragment>
  )
}

export default Support
